module.exports = __webpack_public_path__ + "static/media/user_input_1.33bc4607.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/WxGraphTool/user_input_1.png
// module id = 1772
// module chunks = 0